export function calculateNS(Qs, fd, ft, fr) {
    if (typeof Qs !== 'number' || typeof fd !== 'number' || typeof ft !== 'number' || typeof fr !== 'number') {
        throw new Error('All arguments must be numbers');
    }
    return Qs * fd * ft * fr;
}

export function minSludgeVolume(NS) {
    if (typeof NS !== 'number') {
        throw new Error('All arguments must be numbers');
    }
    return NS * 100;
}


export function sizeOfBasalSludgeTank(NS) {
    if (typeof NS !== 'number') {
        throw new Error('All arguments must be numbers');
    }

    switch (true) {
        case NS <= 2:
            return 2
        case NS <= 4:
            return 4;
        case NS <= 7:
            return 7;
        case NS <= 10:
            return 10;
        case NS <= 15:
            return 15;
        case NS <= 25:
            return 25;
        default:
            return "Ikke tilgjengelig";
    }
}